import { render, staticRenderFns } from "./approval-vehicle-form.vue?vue&type=template&id=474597e6&"
import script from "./approval-vehicle-form.vue?vue&type=script&lang=js&"
export * from "./approval-vehicle-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports